// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"360":"bc052a5c","374":"7283bbd0","487":"d86d7c0b","578":"a9abf73d","766":"9727b61b","788":"8ae6147c","895":"d0d8a25e"}[chunkId] + ".chunk.js";
};